export class AttachmentCategoryDetails {
    public attachmentCategory: string;
}
